import { render } from "./TeamsComponent.vue?vue&type=template&id=f1d49c2a"
import script from "./TeamsComponent.vue?vue&type=script&lang=js"
export * from "./TeamsComponent.vue?vue&type=script&lang=js"

import "./TeamsComponent.vue?vue&type=style&index=0&id=f1d49c2a&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__